import React from "react";
import AppRoutes from './Routes';
import { ToastContainer } from "react-toastify";
import "./App.css";
import Footer from "./Components/Footer";

function App() {
  return (

    <div className="app-container">
      <AppRoutes />
      <ToastContainer />
      <Footer />
    </div>

  );
}

export default App;
